import { FC } from 'react';
import { twJoin } from 'tailwind-merge';

import { CopilotDrawer } from '@/components/CopilotDrawer';
import { Page } from '@/components/Page';
import { PAGE_MARGIN_CLASSNAME } from '@/components/PageLayout';
import { AccountFilterPanel } from '@/components/ResourceFilterPanel/AccountFilterPanel';
import { useFeatureFlags } from '@/context/FeatureFlagProvider';
import { SearchFacetsProvider } from '@/context/SearchFacetsProvider';
import { SearchHeader } from '@/pages/account/components/SearchHeader';
import { AccountSearchResultsContents } from './components/AccountSearchResultsContents';

export const AccountSearchPage: FC = () => {
  const { ai447CatalogAgenticChat } = useFeatureFlags();

  return (
    <Page title={'Search Results'} pageType="searchResults">
      <SearchHeader shouldUseTypeahead={false} />
      <SearchFacetsProvider>
        <div className="flex h-full">
          <span className="flex-0 h-full overflow-y-auto bg-bgMain">
            <AccountFilterPanel />
          </span>
          <span
            className={twJoin(
              'flex-1 overflow-y-auto bg-bgMain',
              PAGE_MARGIN_CLASSNAME,
            )}
          >
            <AccountSearchResultsContents />
          </span>
        </div>
      </SearchFacetsProvider>
      {ai447CatalogAgenticChat && <CopilotDrawer />}
    </Page>
  );
};
